<template>
  <div>
    <QS-h3-title>
      <template slot="title">事故详情</template>
      <template slot="right">
        <el-button v-if="tabType" slot="right" @click="goBack">返回</el-button>
        <el-button type="primary" size="mini" @click="JumpEdit">编辑</el-button>
      </template>
    </QS-h3-title>
    <div class="splitline mt16 mb16" />
    <QS-h4-title title="维保信息" />
    <el-form>
      <column-box
        :source="source"
        separator=":"
        :list="list"
        :column="3"
        label-width="140"
      ></column-box>
      <el-form-item
        :label="'保单附件/图片' + columnSeparator"
        class="alone"
        label-width="140px"
      >
        <div v-if="this.fileList.length > 0">
          <div v-for="(item, index) in this.fileList" :key="'fileList' + index">
            <p v-down="{ url: item.url, name: item.name }" class="blue">
              <i class="el-icon-document"></i>
              {{ item.name }}
            </p>
          </div>
        </div>
        <div v-else>--</div>
      </el-form-item>
    </el-form>
    <div class="content2">
      <QS-common-table
        :data="tableData"
        :columns="headData"
        :pagination="false"
      ></QS-common-table>
    </div>
    <!-- 结算状态 已完成才展示 -->
    <div
      v-if="
        settlementSource &&
        settlementSource.settlementVO &&
        settlementSource.settlementVO.settlementStatus !== null
      "
    >
      <QS-h4-title title="结算信息" />
      <QS-column-box
        label-width="140"
        separator=":"
        :source="settlementSource.settlementVO"
        :column="3"
        :list="settlementList"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getAccidentDetail, queryByType } from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'
import config from '../config'

export default {
  data() {
    return {
      tabType: '', // 客户&车辆详情/个人租赁跳转到个人租赁详情的类型
      settlementSource: {},
      settlementList: [
        {
          key: 'content',
          name: '收款内容',
        },
        {
          key: 'receivableDate',
          name: '收款时间',
        },
        {
          key: 'settlementStatusName',
          name: '结算状态',
        },
        {
          key: 'customerType',
          name: '付款方类型',
        },
        {
          key: 'customerName',
          name: '付款方',
        },
        {
          key: 'remarks',
          name: '备注',
        },
      ],
      list: [
        {
          key: 'id',
          name: '事故单ID',
          alone: true,
        },
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'carModelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'contractId',
          name: '当前合同ID',
        },
        {
          key: 'customerName',
          name: '当前客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'reportDate',
          name: '报案日',
        },
        {
          key: 'claimState',
          name: '出险状态',
        },
        {
          key: 'accidentDate',
          name: '出险日期',
        },
        {
          key: 'accidentType',
          name: '事故类型',
        },
        {
          key: 'accidentStatus',
          name: '事故状态',
        },
        {
          key: 'accidentBlame',
          name: '事故责任',
        },
        {
          key: 'insuranceType',
          name: '保险类型',
        },
        {
          key: 'lossAmount',
          name: '定损金额',
        },
        {
          key: 'claimAmount',
          name: '理赔金额',
        },
        {
          key: 'deductibleAmount',
          name: '免赔金额',
        },
        {
          key: 'repairAmount',
          name: '车辆维修金额',
        },
        {
          key: 'receivableAmount',
          name: '应收金额',
        },
        {
          key: 'customerInsuredAmount',
          name: '客户承担担保金额',
        },
        {
          key: 'accidentPlace',
          name: '事故地点',
        },
        {
          key: 'accidentCauseName',
          name: '事故原因',
        },
        {
          key: 'injurySituationName',
          name: '是否人伤',
        },
        {
          key: 'accidentNumber',
          name: '事故单号',
        },
        {
          key: 'reportNo',
          name: '报案号',
        },
        {
          key: 'payer',
          name: '付款方',
        },
        {
          key: 'payDate',
          name: '付款日期',
        },
        {
          key: 'reportPhone',
          name: '报案电话',
        },
        {
          key: 'driverName',
          name: '驾驶人',
        },
        {
          key: 'driverTel',
          name: '驾驶人联系方式',
        },
        {
          key: 'totalMileage',
          name: '总行驶公里数',
        },
        {
          key: 'repairer',
          name: '维修厂',
        },
        {
          key: 'securityOfficer',
          name: '安全员',
        },
        {
          key: 'accidentDescribe',
          name: '事故及进展描述',
        },
        {
          key: 'remarks',
          name: '备注',
        },
      ],
      source: null,
      needParsePrams: [
        'lossAmount',
        'claimAmount',
        'receivableAmount',
        'customerInsuredAmount',
        'totalMileage',
      ], // 需要转为分的字段
      /* 上传假数据 */
      fileList: [],
      headData: config.call(this).headData,
      tableData: [],
      typeItemsObj: {},
    }
  },
  created() {
    const { tabType, id } = this.$route.query
    this.tabType = tabType
    getAccidentDetail({
      id,
    }).then(({ data }) => {
      this.source = data
      this.settlementSource = data
      Object.keys(data).forEach((key) => {
        this.source[key] = data[key]
        if (
          this.needParsePrams.includes(key) &&
          data[key] !== '' &&
          data[key] !== null &&
          typeof data[key] !== 'undefined'
        ) {
          this.source[key] = this.numberWithCommas(data[key])
        }
        // 保险类型
        if (key === 'insuranceType') {
          data[key] = data[key]
            ? data[key].split(',').map((item) => Number(item))
            : []
        }
      })
      this.tableData = this.source.accidentItemsAddParamList
      this.fileList = this.getEchoUploadFileData(data.attachment, true)
      this.parseEnum()
      this.getFinanceItems()
    })
  },
  methods: {
    // 返回上一级
    goBack() {
      this.$router.go(-1)
    },
    // 获取事故财务项下拉框数据
    getFinanceItems() {
      queryByType({
        type: 5,
      }).then(({ code, data }) => {
        if (code === 1 && data.length > 0) {
          data.forEach((item) => {
            this.typeItemsObj[Number(item.id)] = item.itemName
          })
        }
      })
    },
    // 获取枚举的汉字
    parseEnum() {
      this.source.claimState =
        selectOption.outInsuranceStatusDict[this.source.claimState] // 出险状态
      this.source.accidentType =
        selectOption.accidentTypeDict[this.source.accidentType] // 事故类型
      this.source.accidentStatus =
        selectOption.accidentStatusDict[this.source.accidentStatus] //  事故状态
      this.source.accidentBlame =
        selectOption.accidentResponsibilityDict[this.source.accidentBlame] // 事故责任
      this.source.insuranceType = this.getType() // 保险类型
      this.source.payer = selectOption.plyers[this.source.payer] // 付款方
    },
    // 获取保险类型汉字
    getType() {
      const arr = []
      this.source.insuranceType.forEach((item) => {
        arr.push(selectOption.insuranceTypeDict[Number(item)])
      })
      return arr.join(',')
    },
    JumpEdit() {
      const { id } = this.$route.query
      this.$router.push({
        path: '/vehicle/accident/edit',
        query: { id },
      })
    },
  },
}
</script>

<style lang="less">
.blue {
  color: #2e7eff;
  display: inline-block;
  margin: 0;
}
</style>
